import { fieldMarkers } from "../../../common/constants/export";
import { generateFileName } from "../../../common/helpers/export";
import { exportFilenameTemplates, terms } from "../constants";

export const exportTypes = Object.freeze({
    searchResults: 'amSearchResults',
    breakdownResults: 'breakdownResults',
    fromBreakdownGrowthResults: 'fromBreakdownGrowthResults',
});

export const getAmFilename = ({ date, exportType, office, currentBreakdownTab, isOfficeListBreakdown, fromOfficeBreakdownAndGrowthTab }) => {
    const fromOrTo = currentBreakdownTab?.title === terms.gainedAgents ? terms.from : terms.to;
    return generateFileName(exportFilenameTemplates[exportType] || '', {
        [fieldMarkers.DATE]: date,
        [fieldMarkers.OFFICE]: office?.name || '',
        [fieldMarkers.AM_BREAKDOWN_TAB]: currentBreakdownTab?.title,
        [fieldMarkers.FROM_OR_TO]: isOfficeListBreakdown || fromOfficeBreakdownAndGrowthTab ? '' : fromOrTo,
    });
};

export const getFilename = (exportDetails) => ({
    [exportTypes.searchResults]: getAmFilename(exportDetails),
    [exportTypes.breakdownResults]: getAmFilename(exportDetails),
    [exportTypes.fromBreakdownGrowthResults]: getAmFilename(exportDetails),
});
